import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import { Icon } from '@shared/icons';
import { excludeProps } from '@shared/theme/util';

interface StyledIconButtonProps {
  expanded: boolean;
  hidden: boolean;
  marginDense: boolean;
}

const StyledIconButton = styled(IconButton, {
  name: 'ExpandButton',
  slot: 'IconButton',
  shouldForwardProp: (propName) =>
    excludeProps(propName, ['expanded', 'hidden', 'marginDense']),
})<StyledIconButtonProps>(({ theme, expanded, hidden, marginDense }) => ({
  transform: 'rotate(0deg)',
  transition: theme.transitions.create('transform', {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shortest,
  }),
  ...(expanded && {
    transform: 'rotate(90deg)',
  }),
  ...(hidden && {
    visibility: 'hidden',
    pointerEvents: 'none',
  }),
  ...(marginDense && {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  }),
}));

interface ExpandButtonProps {
  expanded: boolean;
  onClick: () => void;
  hidden?: boolean;
  margin?: 'dense' | 'none';
}

export const ExpandButton = ({
  onClick,
  expanded,
  hidden = false,
  margin = 'none',
}: ExpandButtonProps) => (
  <StyledIconButton
    expanded={expanded}
    hidden={hidden}
    marginDense={margin === 'dense'}
    onClick={onClick}
    size="small"
  >
    <Icon name="chevron_right" />
  </StyledIconButton>
);
